import axios from "axios";
import { getCookie } from "@/utils";
import { BACKEND_BASE_URL, COMMON_SUB_DOMAIN, MASTER_SUB_DOMAIN } from "@/config";
import { getSubdomain } from "@/utils/common";

const axiosInstance = axios.create({
  baseURL: BACKEND_BASE_URL
});

axiosInstance.interceptors.request.use((config) => {
  config.headers["XSM-Domain"] = getCookie("xsm_user_domain");

  // Get subdomain-aware access token
  const subDomain = getSubdomain();
  const defaultSubDomain = subDomain !== "" && subDomain !== COMMON_SUB_DOMAIN ? subDomain : MASTER_SUB_DOMAIN;
  const accessTokenKey = `${defaultSubDomain}_access_token`;

  // Check for subdomain-specific token first, then fallback to generic token
  const accessToken =
    localStorage.getItem(accessTokenKey) || localStorage.getItem("xsm_access_token");

  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }

  return config;
});

export default axiosInstance;
